var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CollapsibleCard } from 'shared/components';
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { TrackedCallback } from '../TrackedCallback';
export var TrackedCollapsibleCard = function (_a) {
    var eventName = _a.eventName, eventProperties = _a.eventProperties, collapsibleCardProps = __rest(_a, ["eventName", "eventProperties"]);
    return (_jsx(TrackedCallback, __assign({ eventType: EVENT_TYPE.CARD_CLICKED, callback: "onChange", eventName: eventName, eventProperties: eventProperties, transformEventProperties: function (isOpen) { return ({ event_type: isOpen ? 'opened' : 'closed' }); } }, { children: _jsx(CollapsibleCard, __assign({}, collapsibleCardProps)) })));
};
